<template>
  <div class="h-screen w-screen flex items-center justify-center flex-col">
    <h2>Ups al parecer no tienes internet</h2>
  </div>
</template>
